(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('.faq-item__trigger').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var item = this.closest('.faq-item');
        var body = item.querySelector('.faq-item__body');
        var isOpen = item.classList.contains('faq-item--open');

        item.classList.toggle('faq-item--open', !isOpen);
        this.setAttribute('aria-expanded', String(!isOpen));

        if (isOpen) {
          body.hidden = true;
        } else {
          body.hidden = false;
        }
      });
    });
  
  } catch(e) { console.error(e); }
})();
})();
